import React from 'react';
import { CheckCircle } from 'lucide-react';

const SuccessMessage: React.FC = () => (
  <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
    <CheckCircle className="w-12 h-12 text-green-600 mx-auto mb-3" />
    <h3 className="text-lg font-semibold text-green-800 mb-2">Thank you for signing up!</h3>
    <p className="text-green-700">We'll notify you as soon as the integration is ready.</p>
  </div>
);

export default SuccessMessage;